module.exports = __webpack_public_path__ + "img/arrow.5c9d48ab.svg";